import {AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';
import {eventWasOutside} from 'common/util/dom';

import {template} from './template';
import {TagEvent, TagJsxProps, TagSize, TagTheme} from './types';
import css from './index.inline.styl';

export class Tag extends Component<null, TagJsxProps['attrs']> {
  static get attrsSchema(): AttrsSchema<TagJsxProps['attrs']> {
    return {
      ...super.attrsSchema,
      clickable: `boolean`,
      icon: `string`,
      removable: `boolean`,
      size: {type: `string`, default: TagSize.Default, enum: Object.values(TagSize)},
      'tag-name': `string`,
      theme: {type: `string`, default: TagTheme.Light, enum: Object.values(TagTheme)},
    };
  }

  get config() {
    return {
      useShadowDom: true,
      css,
      template,
      helpers: {
        TagTheme,
        TagSize,
        remove: (ev: MouseEvent) => {
          ev.stopPropagation();
          this.dispatchEvent(
            new CustomEvent<TagEvent>(`remove`, {detail: {tagName: this.attr(`tag-name`)}}),
          );
        },
        select: (ev: MouseEvent) => {
          const removeTag = this.el.querySelector(`.remove-tag`);
          if (!removeTag || eventWasOutside(ev, removeTag)) {
            this.dispatchEvent(
              new CustomEvent<TagEvent>(`select`, {detail: {tagName: this.attr(`tag-name`)}}),
            );
          }
        },
      },
    };
  }
}

export const TagEl = defineAndMakeJsxFactory<TagJsxProps>(`mp-tag`, Tag);
export const TagReact = panel2react<TagJsxProps>(`mp-tag`, Tag);
